var map = {
	"./1.jpg": "6958",
	"./2.jpg": "707f",
	"./3.jpg": "664f",
	"./4.jpg": "ad93",
	"./team1.png": "feae",
	"./team2.png": "527b",
	"./team3.png": "542b",
	"./team4.png": "36df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d35";